/* RESPONSIBLE TEAM: team-ai-agent */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import AdminSummary, { type AdminSummaryWireFormat } from '../admin-summary';

interface ConversationUnmarkedAsSpamWireFormat {
  admin_summary: AdminSummaryWireFormat;
}

export default class ConversationUnmarkedAsSpam implements RenderableData {
  readonly renderableType = RenderableType.ConversationUnmarkedAsSpam;
  readonly adminSummary: AdminSummary;

  constructor(adminSummary: AdminSummary) {
    this.adminSummary = adminSummary;
  }

  get creatingEntity() {
    return { type: EntityType.Admin, id: this.adminSummary.id };
  }

  static deserialize(json: ConversationUnmarkedAsSpamWireFormat): ConversationUnmarkedAsSpam {
    return new ConversationUnmarkedAsSpam(AdminSummary.deserialize(json.admin_summary));
  }
}
